import { jsx as n } from "react/jsx-runtime";
import a from "react";
import { p as f } from "./purify.es-DRolOuEE.js";
const s = a.forwardRef(({ htmlString: r, ...t }, e) => {
  if (!r)
    return null;
  const o = f.sanitize(r);
  return /* @__PURE__ */ n(
    "div",
    {
      ref: e,
      dangerouslySetInnerHTML: { __html: o },
      ...t
    }
  );
});
export {
  s as T
};
